import i18next from 'i18next';
import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class TenantOnboardingIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async onboard(cfg) {
        try {
            const response = await this.service.onboard(cfg);
            toast.success(
                i18next.t('admin:tenantOnboarding.success', { defaultValue: 'Tenant onboarded' }),
            );
            return { success: true, data: response.data };
        } catch (error) {
            const message = getIntegrationErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }
}
